import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["tld"];
import { Box, Heading, Text } from '@wix/design-system';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import React from 'react';
import { useIsGateRevamp3Enabled } from '../../hooks/useIsGateRevamp3Enabled';
import { GateApiClient } from '../../module/domainSearchGate.apiClient';
import { useOpenTldResults } from '../../hooks/useOpenTldResults';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { getFallback } from '../TldPromotionsWithPrice/TldPromotionsWithPrice';
import { tldPromotionsApiClient } from '../TldPromotionsWithPrice/TldPromotionsWithPrice.apiClient';
import { TldPromotionBox, TldPromotionBoxSkeleton } from './TldPromotionBox';
import s from './tldPromotionBoxes.scss';
const PROMOTIONS_LIMIT = 8;
export const TldPromotionBoxes = () => {
  var _data$tldPromotionsWi;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const openTldResults = useOpenTldResults();
  const _tldPromotionsApiClie = tldPromotionsApiClient.hooks.useTldPromotionsWithPrice({
      limit: PROMOTIONS_LIMIT
    }, true, {
      useErrorBoundary: false
    }),
    data = _tldPromotionsApiClie.data,
    isLoading = _tldPromotionsApiClie.isLoading,
    error = _tldPromotionsApiClie.error;
  const isChipsRevamp = useIsGateRevamp3Enabled();
  const _usePremiumEssentials = usePremiumEssentialsContext(),
    siteId = _usePremiumEssentials.siteId;
  const _GateApiClient$hooks$ = GateApiClient.hooks.useTldsEligibleForVoucher({
      msid: siteId
    }, isChipsRevamp),
    isVoucherStateLoading = _GateApiClient$hooks$.isLoading;
  const promotions = error || !(data != null && (_data$tldPromotionsWi = data.tldPromotionsWithPrice) != null && _data$tldPromotionsWi.length) ? getFallback(t) : data.tldPromotionsWithPrice;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    align: "center",
    gap: "16px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    align: "center",
    gap: "15px",
    paddingTop: "40px"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "24px 0 18px 0"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t('domain_search_gate.domain_gate.tld_section.header'))), /*#__PURE__*/React.createElement("div", {
    className: s.grid
  }, isLoading || isVoucherStateLoading ? Array.from({
    length: PROMOTIONS_LIMIT
  }, (_, index) => /*#__PURE__*/React.createElement(TldPromotionBoxSkeleton, {
    key: index
  })) : promotions.map((_ref, index) => {
    let tld = _ref.tld,
      promotion = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(TldPromotionBox, _extends({
      key: promotion.id
    }, promotion, {
      tld: tld,
      onClick: tld ? () => {
        var _promotion$pricing, _promotion$pricing2;
        return openTldResults(tld, {
          position: index + 1,
          numOfTlds: promotions.length,
          tldPrice: ((_promotion$pricing = promotion.pricing) == null ? void 0 : _promotion$pricing.price) ?? undefined,
          isSale: Boolean((_promotion$pricing2 = promotion.pricing) == null ? void 0 : _promotion$pricing2.originalPrice)
        });
      } : undefined
    }));
  }))), /*#__PURE__*/React.createElement(Box, {
    className: s.disclaimer
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    light: true
  }, t('domain_search_gate.domain_gate.pricing_disclaimer'))));
};
//# sourceMappingURL=TldPromotionBoxes.js.map